function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { memo } from 'react';
import { ApiContext, ForceUpdateContext } from '../utils/context.js';
import TabPropsManager from './tabPropsManager.js';
import PropTypes from 'prop-types';

var TabComponent = function TabComponent(props) {
  React.useContext(ForceUpdateContext);

  var id = props.id,
      selectedTabID = props.selectedTabID,
      api = React.useContext(ApiContext),
      TabInnerComponent = api.getOption('tabComponent'),
      tabObj = api.getTab(id),
      propsManager = new TabPropsManager({
    api: api,
    id: id,
    isSelected: selectedTabID === id
  }),
      clkHandler = function clkHandler(e) {
    api.eventHandlerFactory({
      e: e,
      id: id
    });
  };

  return /*#__PURE__*/React.createElement("li", _extends({}, propsManager.getTabProps(), {
    onClick: function onClick(e) {
      clkHandler(e);
    }
  }), /*#__PURE__*/React.createElement(TabInnerComponent, propsManager.getTabInnerProps(), tabObj.title), tabObj.closable ? /*#__PURE__*/React.createElement("span", propsManager.getCloseIconProps(), "\xD7") : null);
};

var Tab = /*#__PURE__*/memo(TabComponent, function (oldProps, newProps) {
  var id = oldProps.id,
      oldActiveId = oldProps.selectedTabID,
      newActiveId = newProps.selectedTabID;
  return oldActiveId === newActiveId || id !== oldActiveId && id !== newActiveId;
});
export default Tab;